import {useEffect,useState,useContext} from 'react';
import { Context } from '../context/UserContext';
import { useEntityCrud } from '../hooks/useEntityCrud';
import { toast } from 'react-toastify';

const Settings = () => {

    const context = useContext(Context);

    const businessId = context.businessId
    const { readData: updateSettings } = useEntityCrud('Config/changeNtificationStatus');
    const { readData: getSettings } = useEntityCrud(`Config/getNtificationSetting?businessId=${businessId}`);
    const [settings,setSettings] = useState({});

    useEffect(() => {
        getSettings().then(({data}) => {
            if(data.status)
                setSettings(data.result);
        })
    },[])

    const submit = () => {
        const postedData = {
            businessId,
            sms: settings.sms == true,
            notify: settings.notify == true
        }
        updateSettings(postedData).then(({data}) => {
            if(data.status)
                toast.success('تنظیمات با موفقیت به روزرسانی شد')
            else
                toast.error('به روزرسانی تنظیمات ناموفق بود')
        })
    }

    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">
                    تنظیمات
                </div>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3 col-6">
                        <label>
                            <input type="checkbox" checked={settings?.sms} onChange={e => setSettings({...settings,sms: e.target.checked})} />
                            اعلان سفارش جدید در صفحه داشبورد
                        </label>
                    </div>
                    <div className="col-md-3 col-6">
                        <label>
                            <input type="checkbox" checked={settings?.notify} onChange={e => setSettings({...settings,notify: e.target.checked})} />
                            اعلان سفارش جدید از طریق پیامک
                        </label>
                    </div>
                </div>
                <button className="btn btn-success mt-3" onClick={submit}>ذخیره تغییرات</button>
            </div>
        </div>
    )
}
export default Settings;